<template>
    <div class="modal" v-if="imagesLightBox.show">

        <!-- The Close Button -->
        <span class="close" @click="imagesLightBox.show = false">&times;</span>
        <!-- Modal Content (The Image) -->
        <div class="modal-content">
            <b-carousel
                v-model="manageSlide.slide"
                :interval="4000"
                controls
                indicators
                background="#ababab"
                img-width="800"
                img-height="455"
                style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
            >
                <b-carousel-slide v-for="(img, index) in imagesLightBox.image" :key="index">
                    <template #img>
                        <img
                            :class="[`d-block w-100`]"
                            width="700"
                            height="400"
                            :src="img.src"
                            :alt="img.name"
                        >
                    </template>
                </b-carousel-slide>
            </b-carousel>        
        </div>
        <div class="modal-display-image my-4 py-5">
            <div class="row">
                <div class="col-4" v-for="(img, index) in imagesLightBox.image" :key="index">
                    <div class="card shadow" >
                        <img class="cursor-pointer mw-100" height="125" :src="img.src" @click="selectImageSlide( index )">
                    </div>
                </div>
            </div>
        </div>   
    </div>
</template>
<script>
export default {
    props: {
        imagesLightBox: Object
    },
    data(){
        return{
            manageSlide:{
                slide: 0,
                sliding: null,
            } 
        }
    },
    methods: {
        selectImageSlide(index){
            this.manageSlide.slide = index;
        },
        onSlideStart(slide) {
            this.manageSlide.sliding = true
        },
        onSlideEnd(slide) {
            this.manageSlide.sliding = false
        },
    },
}
</script>
<style scoped>

.modal {
  display: block;
  position: fixed; /* Stay in place */
  z-index: 102; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  display: block;
  width: 100%;
  max-width: 700px;
}

.modal-display-image {
  margin: auto;
  display: block;
  width: 100%;
  max-width: 700px;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content{
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
}
</style>